import { observer } from 'mobx-react';

function Skeleton() {
  return (
    <div className="flex flex-col justify-between py-5 px-2.5 md:flex-row lg:px-12 mt-1 animate-pulse">
      <div className="flex flex-col md:flex-row">
        {[...Array(3)].map((_, index) => (
          <div className="mr-3" key={index}>
            <div className="h-5 w-12 bg-gray-300 rounded mb-2"></div>
            <div className="h-8 w-48 bg-gray-300 rounded"></div>
          </div>
        ))}
      </div>
      <div>
        <div className="h-5 w-12 bg-gray-300 rounded mb-2"></div>
        <div className="h-8 w-60 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
}

export default observer(Skeleton);
